import { useState, useEffect } from "react";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost, httpPatch } from "../../../api";

import MDPopup from "../../../components/MDPopup";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import MDSelect from "../../../components/MDSelect";


const Page = (props) => {
	const { user } = useAuthContext();

	const [docName, setDocName] = useState("");
	const [docUrl, setDocUrl] = useState("");
	const [docType, setDocType] = useState("document");

	const [validSubmit, setValidSubmit] = useState(false);

	useEffect(() => {
		setValidSubmit(!!docName && !!docUrl && !!docType);
	}, [docName, docUrl, docType])

	useEffect(() => {
		setDocName(props.doc.name);
		setDocUrl(props.doc.url);
		setDocType(props.doc.type)

		setValidSubmit(false)
	}, [props.open])

	const handleSubmit = async () => {
		let response;

		if (props.doc.id != null){
			response = await httpPatch(process.env.REACT_APP_URL_BASE+`/document/update`, {
				name: docName,
				url: docUrl,
				type: docType,
				id: props.doc.id
			})
		}else {
			response = await httpPost(process.env.REACT_APP_URL_BASE+`/document/create`, {
				name: docName,
				type: docType,
				url: docUrl
			})
		}

		if (response.status != 201 && response.status != 200){
            alert("Something went wrong");
            console.log(response);
            return
        }

        props.setRefreshed(true);
        props.close();
	}


	return <>
		<MDPopup display="flex" flexDirection="column" justifyContent="center" alignItems="center" open={props.open}>
	        <MDTypography variant="h3" color="info" textAlign="center" fontWeight="bold">Add new document</MDTypography>

	        <br />

	        <MDBox width="50%">
	          <MDTypography variant="h6" color="text">Document Name (Use unique name to make it easy to remember) :</MDTypography>
	          <MDInput type="text" value={docName} onChange={(e) => setDocName(e.target.value)} sx={{width: "100%"}} />
	        </MDBox>

	        <br />

	        <MDBox width="50%">
	          <MDTypography variant="h6" color="text">Document Url :</MDTypography>
	          <MDInput type="url" value={docUrl} onChange={(e) => setDocUrl(e.target.value)} sx={{width: "100%"}} />
	        </MDBox>

	        <br />

	        <MDBox width="50%">
	          <MDTypography variant="h6" color="text" sx={{marginBottom: "1em"}}>Document Type :</MDTypography>

	          <MDSelect label="Select Document Type" value={docType} menu={[{value: "document", label: "Document"}, {value: "software", label: "Software"}]} onChange={(e) => setDocType(e.target.value)} sx={{width: "100%"}} />
	        </MDBox>

	        <br />

	        <MDBox width="70%" textAlign="center">
	          <MDButton onClick={handleSubmit} disabled={!validSubmit} variant="text" color="success">Save</MDButton>
	          <MDButton variant="outlined" color="error" onClick={props.close}>Cancel</MDButton>
	        </MDBox>
	    </MDPopup>
	</>
}

export default Page